<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <template v-if="broadcast && !videoAdLoading && categories && broadcast.stage !== 'scheduled' && !streamEnded && !broadcast.external_url && !queued">
          <jw-player
            :videoAd="videoAd"
            :broadcast="broadcast"
            :key="broadcast.id"
            :hideLogoUrl="this.isForChannel3()"
            ref="streamPlayer"
            @clicked="adClicked"
            @error="handleError"
            v-show="!connecting"
          ></jw-player>
        </template>
        <template v-if="connecting || (broadcast && broadcast.stage === 'scheduled') || streamEnded || (broadcast && broadcast.external_url) || (broadcast && queued)">
          <div class="playerMessageContainer">
            <div class="text d-flex align-center justify-center flex-wrap">
              <template v-if="broadcast.external_url">
                <div class="text-center fullwidth">
                  <p class="text-center" v-if="broadcast.stage === 'scheduled'">
                    Scheduled:
                    <b>
                      {{ broadcast.weekday }}, {{ broadcast.date_formatted }} @
                      {{ broadcast.stream_time_formatted }}
                    </b>
                  </p>
                  <p>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn :href="broadcast.external_url" target="_blank" v-on="on">
                          External Site
                          <v-icon right color="primary">
                            mdi-open-in-new
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        <template v-if="broadcast.stage === 'live'">
                          This Broadcast is available at...
                        </template>
                        <template v-else-if="broadcast.stage === 'scheduled'">
                          This Broadcast will be available at...
                        </template>
                        <template v-else-if="broadcast.stage === 'vod'">
                          A recording of this Broadcast should be available at...
                        </template>
                        <br />
                        {{ broadcast.external_url }}
                      </span>
                    </v-tooltip>
                  </p>
                </div>
              </template>
              <template v-else-if="queued && queuePosition != null && !streamEnded">
                <p class="text-center mx-4 my-2 text-caption text-sm-body-1">
                  <span class="font-weight-medium">
                    We are currently experiencing abnormally high traffic volume.
                  </span>
                  <br />
                  <span>
                    You have been placed in queue and will be automatically connected to the video stream.
                  </span>
                  <br />
                  <br />
                  <span class="font-weight-medium ">
                    There are about {{ queuePositionCeil }} ahead of you in queue.
                  </span>
                  <br />
                  <br />
                  <span>
                    In order to keep your position in queue,
                  </span>
                  <br />
                  <span class="text-uppercase font-weight-bold">
                    do not refresh or leave this page.
                  </span>
                </p>
              </template>
              <template v-else-if="connecting && !streamEnded">
                <div class="text-center fullwidth">
                  <img src="/img/local_10_tv.svg" class="connectingLogo" />
                  <br />
                  Connecting...
                  <br />
                  <div style="width: 50%" class="mx-auto">
                    <v-progress-linear indeterminate :size="50" color="primary" class="my-3"></v-progress-linear>
                  </div>
                </div>
              </template>
              <template v-else-if="streamEnded">
                <p class="text-center mx-auto" style="max-width: 400px;">
                  It looks like this live stream has ended.
                  <br />
                  Check back later to watch the recording!
                  <br />
                  <v-btn @click="reloadPage" :loading="loading" :disabled="loading" class="mt-2">
                    reload
                    <v-icon right>mdi-refresh</v-icon>
                  </v-btn>
                </p>
              </template>
              <template v-else-if="broadcast && broadcast.stage === 'scheduled'">
                <p class="text-center">
                  This broadcast is scheduled to begin streaming
                  <br />
                  {{ broadcast.weekday }}, {{ broadcast.date_formatted }}
                  <br />
                  @ {{ broadcast.stream_time_formatted }}
                  <br />
                  <v-btn icon @click="getBroadcast" :loading="loading" :disabled="loading" class="mt-2">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </p>
              </template>
            </div>
          </div>
        </template>
        <!-- Mobile Banner Ad Loader -->
        <v-col v-if="isMobile">
          <MainPageAd class="mx-auto" :mainPageAd="bannerAd" @clicked="adClicked" v-if="bannerAd"></MainPageAd>
        </v-col>
        <template v-if="broadcast">
          <v-row>
            <v-col cols="12" md="6">
              <h2>
                {{ broadcast.title || '' }}
              </h2>
              <h3 class="font-italic">
                {{ broadcast.subtitle || '' }}
              </h3>
            </v-col>
            <v-col cols="12" md="6">
              <p class="body-2 text-md-right">
                <template v-if="broadcast && broadcast.display_date">
                  {{ broadcast.date_formatted }}
                </template>
              </p>
            </v-col>
            <v-col cols="12">
              <p class="body-1 font-italic">
                {{ broadcast.description || '' }}
              </p>
            </v-col>
          </v-row>
        </template>
        <template v-if="categories">
          <v-row>
            <v-col cols="12" class="d-flex justify-start align-center flex-wrap">
              Categories:
              <span v-for="category in categories" :key="category.id">
                <v-chip small class="mx-1" v-if="category.id !== 43" :to="`/broadcasts/${category.id}/${category.seo_name}`">
                  {{ category.name }}
                </v-chip>
              </span>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <p class="text-center">
            <v-progress-circular indeterminate :size="50" color="primary"></v-progress-circular>
          </p>
        </template>
      </v-col>
      <!-- Desktop Banner Ad Loader -->
      <v-col cols="12" sm="5" md="4" lg="3" class="text-center" v-if="!isMobile">
        <banner-ad class="mr-auto ml-auto ml-md-0" :bannerAd="bannerAd" @clicked="adClicked" v-if="bannerAd"></banner-ad>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col>
        <broadcast-carousel
          name="Suggested"
          :suggested="true"
          :broadcastId="id"
        ></broadcast-carousel>
      </v-col>
    </v-row>

    <v-dialog persistent v-model="dialog" width="400">
      <v-card class="mx-auto">
        <v-card-title class="headline">
          Playback Error
        </v-card-title>
        <v-card-text>
          This video may require Adobe Flash to be installed and enabled in your browser.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            Okay
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import serverDatetimeMixin from '../mixins/serverDatetimeMixin';
import { getCookie, setCookie, deleteCookie } from '../utils';
import {mapGetters} from 'vuex';

export default {
  mixins: [serverDatetimeMixin],
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    seoName: {
      type: String,
      required: false,
    },
  },
  data: () => ({
    loading: true,
    broadcast: null,
    videoAd: null,
    videoAdLoading: true,
    bannerAd: null,
    categories: null,
    requiresFlash: false,
    dialog: false,
    reconnectTimeout: null,
    connecting: false,
    streamEnded: false,
    queued: false,
    queueId: -1,
    queueSecret: -1,
    queuePosition: null,
    queueTimeout: null,
  }),
  computed: {
    ...mapGetters(['isMobile']),
    queuePositionCeil: function() {
      if(this.queuePosition) {
        if(this.queuePosition < 5) {
          return 5;
        } else if(this.queuePosition < 100) {
          return Math.ceil(this.queuePosition/10)*10;
        } else {
          return Math.ceil(this.queuePosition/50)*50;
        }
      }

      return null;
    },
  },
  methods: {
    getBroadcast() {
      this.loading = true;
      let params = {
        broadcastId: this.id,
      };
      axios.get('getBroadcast', { params }).then(res => {
        if (res.data.success) {
          this.queued = res.data.queued;

          if(!this.queued) {
            this.getVideoAd();
          } else {
            this.getQueueStatus();
          }

          this.getBannerAd();
          this.catchInternal(res.data.categories);
          this.broadcast = res.data.broadcast;
          this.categories = res.data.categories;
          this.detectFlashProblems();
          document.title = `${this.$baseTitle} - ${this.broadcast.title}`;
        } else {
          this.$router.push({ name: 'Broadcasts' });
        }
        this.loading = false;
      });
    },
    getQueueStatus() {
      let params = {
        qid: this.queueId,
        qs: this.queueSecret,
      };

      axios.get('getQueueStatus',{ params })
        .then(res => {
          if(res.data.success) {
            let queueData = res.data.status;
            this.queueId = queueData.id;
            this.queueSecret = queueData.secret;
            this.queuePosition = queueData.position;

            if(queueData.admitted) {
              this.queueAdmit();
            } else {
              clearTimeout(this.queueTimeout);
              this.queueTimeout = setTimeout(() => {
                this.getQueueStatus();
              }, 15000);
            }
          } else {
            this.$router.push({ name: 'Broadcasts' });
          }
        })
        .catch(() => {
          this.queued = false;
          this.streamEnded = true;
        });
    },
    queueAdmit() {
      if(this.queued) {
        clearTimeout(this.queueTimeout);
        this.queued = false;
        this.getVideoAd();
      }
    },
    getVideoAd() {
      this.videoAdLoading = true;
      let params = {
        broadcastId: this.id,
      };
      axios.get('getVideoAd', { params }).then(res => {
        if (res.data.success) {
          this.videoAd = res.data.videoAd;
        }
        this.videoAdLoading = false;
      });
    },
    getBannerAd() {
      this.loading = true;

      let platformIndicator = null;
      if (this.isMobile) {
        platformIndicator = 'mobile';
      } else {
        platformIndicator = 'desktop' 
      }

      let params = {
        broadcastId: this.id,
        targetPlatform: platformIndicator,
      };
      axios.get('getBannerAd', { params }).then(res => {
        if (res.data.success) {
          this.bannerAd = res.data.bannerAd;
        }
        this.loading = false;
      });
    },
    catchInternal(categories) {
      categories.forEach(category => {
        if (category.id == 31) {
          const internalPassCode = getCookie('teamhive_internal');
          const passCodeValid = internalPassCode === 'safety';
          if (passCodeValid) {
            setCookie('teamhive_internal', 'safety', 2);
          } else {
            const passCode = prompt('Please enter the pass code');
            if (passCode === 'safety') {
              setCookie('teamhive_internal', 'safety', 2);
            } else {
              deleteCookie('teamhive_internal');
              let snackbar = {
                color: 'error',
                timeout: 3000,
                text: 'You are not authorized to view this broadcast',
              };
              this.$store.dispatch('addSnackbar', snackbar);
              this.$router.push({ name: 'Broadcasts' });
            }
          }
        }
      });
    },
    adClicked() {
      setTimeout(() => {
        this.$refs.streamPlayer.player.pause();
      }, 30);
    },
    detectFlashProblems() {
      let match = this.broadcast.file.match(/.flv/g);
      if (match) {
        this.requiresFlash = true;
      } else {
        this.requiresFlash = false;
      }
    },
    handleError(e) {
      console.log(e.code);
      if (this.requiresFlash) {
        this.$gtag.experience('error_jwplayer', 'Requires Flash');
        this.dialog = true;
      } else {
        this.getBroadcast();
        clearTimeout(this.reconnectTimeout);
        if (this.nearScheduledEnd()) {
          this.$gtag.experience('error_jwplayer', 'Live Stream Ended');
          this.streamEnded = true;
        } else {
          this.$gtag.experience('error_jwplayer', 'Unable to Connect to stream');
          this.connecting = true;
          this.reconnectTimeout = setTimeout(() => {
            this.connecting = false;
            this.$refs.streamPlayer.reconnect();
          }, 10000);
        }
      }
    },
    reloadPage() {
      this.$router.go(this.$router.currentRoute);
    },
    nearScheduledEnd() {
      let broadcast = this.broadcast;
      let now = new Date().getTime();
      let start = this.parseDateTime(broadcast.start).getTime();
      let end = this.parseDateTime(broadcast.end).getTime();
      let scheduledLength = Math.abs(end - start) / 1000 / 60;
      let actualLength = Math.abs(start - now) / 1000 / 60;
      // If 75% of the scheduled broadcast has completed
      if (actualLength >= scheduledLength * 0.75) {
        return true;
      }
      return false;
    },
    isForChannel3() {
      let channel3 = this.categories.find(category => {
        return category.id === 44 || category.id === 6;
      });
      if (channel3) {
        return true;
      }
      return false;
    },
  },
  created() {
    this.getBroadcast();
  },
  beforeDestroy() {
    clearTimeout(this.reconnectTimeout);
  },
  watch: {
    id(newValue) {
      this.broadcast = null;
      this.videoAd = null;
      this.bannerAd = null;
      this.categories = null;
      this.requiresFlash = false;
      this.dialog = false;
      this.reconnectTimeout = null;
      this.connecting = false;
      this.streamEnded = false;
      this.getBroadcast();
      this.getSuggestedBroadcasts(newValue);
      this.queued = false;
      this.queueId = -1;
      this.queueSecret = -1;
      this.queuePosition = null;
      this.queueTimeout = null;
    },
  },
};
</script>
<style scoped lang="scss">
.playerMessageContainer {
  padding-top: 56.25%;
  background-color: #1e1e1e;
  position: relative;
}
.playerMessageContainer .text {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.playerMessageContainer .text .fullwidth {
  width: 100%;
}
.connectingLogo {
  height: 75px;
  width: 75px;
}
</style>
